<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "BackofficeNavManagement",
}
</script>

<style scoped>

</style>
